import React, { useEffect, useState } from "react";
import "./App.css";
import Thememe from "./Pages/Thememe";
import { UserInfoProvider } from "../src/Providers/theData";
import { isMobile } from "react-device-detect";
import TelegramDesk from "./components/TelegramRedirect";
import ReactGA from "react-ga4";
import { AudioProvider } from "../src/Providers/AudioProvider";
import Gauth from "./Pages/Gauth/Gauth";
import { decryptMessage } from "./utils/crypto";
import QuegaAnnouncement from "./Pages/Tv/Advertisement/QuegaAnnouncement/announcement";

function App() {
  const [redirecting, setRedirecting] = useState(false);
  const [isLandscape, setIsLandscape] = useState(
    window.innerWidth > window.innerHeight
  );
  const [isKeyboardActive, setIsKeyboardActive] = useState(false);
  const [viewportHeight, setViewportHeight] = useState(window.innerHeight);
  const IsQa = process.env.REACT_APP_IS_QA == "true" ? true : false;
  const updateOrientation = () => {
    // Only update orientation if keyboard is not active
    if (!isKeyboardActive) {
      setIsLandscape(window.innerWidth > window.innerHeight);
    }
  };
  const IsLocalServer =
  process.env.REACT_APP_IS_LOCAL_SERVER == "true" ? true : false;
  const [isTelegramWebApp, setIsTelegramWebApp] = useState(
    process.env.REACT_APP_IS_TELEGRAM_WEBAPP === "true" ? true : false
  );
  const [isWebApp, setIsWebApp] = useState(false);
  const styles = {
    warning: {
      textAlign: "center",
      padding: "20px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "#000000",
      color: "#4df038",
      fontSize: "18px",
      height: "100vh",
      textTransform: "uppercase",
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      margin: 0,
    },
  };
  useEffect(() => {
    window.addEventListener("resize", updateOrientation);

    // Add event listeners for keyboard detection
    const handleFocus = () => {
      setIsKeyboardActive(true);
      // Store the current viewport height when keyboard appears
      setViewportHeight(window.innerHeight);
    };

    const handleBlur = () => {
      setIsKeyboardActive(false);
      // Restore the viewport height when keyboard disappears
      setViewportHeight(window.innerHeight);
      // Check orientation after keyboard is dismissed
      updateOrientation();
    };

    // Add event listeners to all input and textarea elements
    document.addEventListener("focusin", handleFocus);
    document.addEventListener("focusout", handleBlur);

    // Handle visual viewport changes (for modern browsers)
    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", () => {
        setViewportHeight(window.visualViewport.height);
      });
    }

    return () => {
      window.removeEventListener("resize", updateOrientation);
      document.removeEventListener("focusin", handleFocus);
      document.removeEventListener("focusout", handleBlur);
      if (window.visualViewport) {
        window.visualViewport.removeEventListener("resize", () => {
          setViewportHeight(window.visualViewport.height);
        });
      }
    };
  }, [isKeyboardActive]);

  // testing //

  // Log interaction for custom events
  const logInteraction = (action, label) => {
    ReactGA.event({
      category: "User Interaction",
      action: action,
      label: label,
    });
  };
  useEffect(() => {
    const updateVh = () => {
      // Use the current viewport height instead of window.innerHeight
      const vh = viewportHeight * 0.01; // 1% of the viewport height
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    };

    updateVh(); // Initial calculation
    window.addEventListener("resize", updateVh); // Update on resize

    return () => {
      window.removeEventListener("resize", updateVh);
    };
  }, [viewportHeight]);
  // Log page views dynamically
  const logPageView = (pagePath, screenClass) => {
    ReactGA.send({
      hitType: "pageview",
      page_path: `/${pagePath}`,
      page_title: screenClass, // Dynamically set the page title
    });
    ReactGA.event({
      category: "Page View",
      action: "User Accessed Page",
      label: screenClass, // Track the screen class as an additional label
    });
  };
  // Navigate and log the page view
  const goToThePage = (page, screenClass) => {
    logPageView(page, screenClass);
    // Custom navigation logic to go to a specific page (using your routing method)
  };
  // Set user properties on app load
  const urlParams = new URLSearchParams(window?.location?.search);
  const GetWebId = urlParams?.get("auth");
  // const getWebUSerID= Cookies.get("googleId");
  // console.log(getWebUSerID,'getWebUSerID');

  useEffect(() => {
    const urlParams = new URLSearchParams(window?.location?.search);
    const name = urlParams?.get("name");
    const googleId = urlParams?.get("googleId");
    const RefId = urlParams?.get("startapp");
    if (RefId) {
      localStorage.setItem("RefId", RefId);
    }
    if (googleId) {
      // Save to localStorage (GAuth callback – web app only)
      localStorage.setItem("UserName_Web", decryptMessage(name));
      localStorage.setItem(
        "GoogleId_Web",
        decryptMessage(googleId?.replace(/ /g, "+"))
      );
      // Stay in webapp and show QuegaAnnouncement (no external redirect)
      const base = window.location.origin + window.location.pathname;
      window.location.replace(base + "?auth=success");
    }
  }, []);

  useEffect(() => {
    ReactGA.initialize("G-DSQDP0KQ7H");
    ReactGA.set({ user_role: "admin" });

    const isTelegram = window.Telegram?.WebApp?.initDataUnsafe?.user;

    if (isTelegram) {
      const tg = window.Telegram.WebApp;
      tg.ready();
      setIsTelegramWebApp(true);

      logInteraction(
        "WebApp Opened",
        tg.initDataUnsafe?.user?.id || "Unknown User"
      );

      tg.onEvent("mainButtonClicked", () => {
        logInteraction("Main Button Clicked");
      });
      tg.onEvent("webAppDataReceived", (data) => {
        logInteraction("Data Received", JSON.stringify(data));
      });
    } else {
      setIsWebApp(true); // Any non-telegram web access (GAuth / webapp)
    }
    if (isMobile) {
      setRedirecting(true);
    }
  }, []);

  // Web (GAuth) user: show QuegaAnnouncement when already authenticated
  const hasWebAuth =
    GetWebId === "success" || !!localStorage.getItem("GoogleId_Web");

  return (
    <UserInfoProvider>
      <AudioProvider>
        {isLandscape && redirecting && !isKeyboardActive ? (
          <div className="landscape-warning" style={styles.warning}>
            Please switch back to Mobile portrait mode for the best Gaming
            experience.
          </div>
        ) : !isMobile && !IsQa ? (
          <TelegramDesk />
      ) : (isTelegramWebApp && isMobile) || IsLocalServer ? (
          // <Thememe />
          <QuegaAnnouncement />
        ) : isWebApp ? (
          hasWebAuth ? <QuegaAnnouncement /> : <Gauth />
        ) : (
          <TelegramDesk />
        )}
      </AudioProvider>
    </UserInfoProvider>
  );
}
export default App;
